
<v-card elevation="10" class="doc-panel pa-2" v-if="document">
    <c-column-header
        class  = "primary"
        :label = "document.name"
    >
        <template v-slot:filter>
            <div class="v-flex" style="margin-top: -2px">
                <v-switch
                    v-model = "collective"
                    color   = "white"
                    class   = "mt-0 pt-1"
                    :ripple = "false"
                    hide-details
                    @change = "onChange"
                >
                    <template v-slot:label>
                        <div style="width: 300px">
                            <span v-if="collective" class="white--text">Dokument ist allen Anlagen zugeordnet</span>
                            <span v-if="!collective"  class="white--text">Dokument ist Anlage {{ document.unitName }} zugeordnet</span>
                        </div>
                    </template>
                </v-switch>
                <c-toolbar-button
                    icon   = "mdi-close"
                    color  = "white"
                    size   = "22"
                    @click = "onClose"
                    tooltip="Dokument schließen"
                />
            </div>
        </template>
    </c-column-header>
    <c-dms-viewer
        class     = "w-100 white mt-1"
        style     = "height: calc(100% - 35px)"
        :document = "documentId"
    />
</v-card>
